import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const airlockDigital = defineConnector({
  identifier: "airlockDigital",
  name: "Airlock Digital",
  tagLine: "Application allowlisting for endpoints",
  logo,
  protocol: "http",
  tags: ["security", "it"],
  defaultUrlPattern: ({ apiAddress }) =>
    apiAddress
      ? `${apiAddress.replace(/\./g, "\\.").replace(/\/$/, "")}/v1/.*`
      : "",
  auth: (app) => headerAuth([{ name: "X-ApiKey", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Airlock Digital dashboard, open **Administrative → API Keys** and generate a key. See the [Airlock Digital API docs](https://api.airlockdigital.com/).",
        },
      ],
    },
    {
      title: "Enter your API details",
      items: [
        {
          kind: "url",
          label: "API address",
          placeholder: "https://airlock.example.com",
          required: true,
          target: { kind: "configuration", field: "apiAddress" },
          helperText: "The base URL of your Airlock Digital server.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiAddress }) => ({
      url: `${(apiAddress ?? "").replace(/\/$/, "")}/v1/license/get`,
      method: "POST",
    }),
  },
});
